/** Only persisted integer identities may address a busy-time mutation. */
export const persistedBusytimeId = value => {
  if (typeof value === 'string' && !/^\d+$/.test(value)) return null;
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const busytimeSalonContext = user => String(user?.salon?.id ?? user?.salon_id ?? '');
export const busytimeLoadMessage = 'Select a saved busy time again or reload it before removing.';
